class SidebarPopup extends HTMLElement {
	constructor() {
	  super();
	  this.modal = this;
	  this.modalBg = this.modal.querySelector(".sidebar-popup__overlay");
	  this.modalDialog = this.modal.querySelector(".sidebar-popup__dialog");
	  this.modalClose = this.modal.querySelector(".sidebar-popup__close");
	  this.modalClose.addEventListener('click', this.close.bind(this))
  
	  this.modal.addEventListener("click", function(e) {
		if(e.target === this.modalBg) {
		  this.close()
		}
	  })
	}
  
	close() {
      this.modalDialog.classList.remove('animate');
      setTimeout(()=>{
        this.modal.classList.remove('show');
      },500)
	  document.body.classList.remove('overflow-hidden');
	}
  
	open(){
		this.modal.classList.add('show');
        setTimeout(()=>{
            this.modalDialog.classList.add('animate');
        },1)
		document.body.classList.add('overflow-hidden');
	}
	
  }
  
  customElements.define('sidebar-popup', SidebarPopup);




//   POPUP WINDOW
  class PopupWindow extends HTMLElement {
	constructor() {
	  super();
	  this.modal = this;
	  this.modalBg = this.modal.querySelector(".popup-window__overlay");
	  this.modalClose = this.modal.querySelector(".popup-window__close");
	  this.modalClose.addEventListener('click', this.close.bind(this))
  
	  this.modal.addEventListener("click", function(e) {
		if(e.target === this.modalBg) {
		  this.close()
		}
	  })
	}
  
	close() {
      this.modal.classList.remove('open');
	  document.body.classList.remove('overflow-hidden');
	}
  
	open(){
		this.modal.classList.add('open');
		document.body.classList.add('overflow-hidden');
	}
	
  }
  
  customElements.define('popup-window', PopupWindow);


// BUTTONS TO OPEN SIZE GUIDE
let sizeGuideBtns = document.querySelectorAll('.open-size-guide-popup-btn');

if(sizeGuideBtns.length){
	sizeGuideBtns.forEach((btn)=>{
		btn.addEventListener('click',()=>{
			let sizeGuidePopup = document.querySelector('.popup-window--size-guide');

			if(sizeGuidePopup){
				sizeGuidePopup.open();
			}
		})
	})
}


// BUTTONS TO OPEN WHATS THE DIFFERENCE
let whatsTheDifferenceBtns = document.querySelectorAll('.open-whats-the-difference-popup');

if(whatsTheDifferenceBtns.length){
	whatsTheDifferenceBtns.forEach((btn)=>{
		btn.addEventListener('click',()=>{
			
			let whatsTheDifferencePopup = document.querySelector('.popup-window--whats-the-difference');
			console.log(whatsTheDifferencePopup)
			
			if(whatsTheDifferencePopup){
				whatsTheDifferencePopup.open();
			}
		})
	})
}